import BlockReplacement from './base/block-replacement';
import Paragraph from '@intercom/embercom-composer/blocks/types/paragraph';
export default BlockReplacement.extend().reopenClass({
  tryReplacement(block, mutationResult) {
    let lastThreeChars = block.get('text').slice(-3);
    if (['```', '\n\n\n'].includes(lastThreeChars)) {
      block.rightTrim();
      let p = Paragraph.create({
        config: block.get('config')
      });
      mutationResult.set('blocksToAdd', [p]);
    }
  }
});